import { useLocation } from "react-router-dom";
import companyLogo from "../assets/2.png";

export default function Header({ onLogout, user }) {
  const { pathname } = useLocation();
  const isInvite = pathname.startsWith("/invite");

  return (
    <header className="p-[2rem] border-b bg-card">
      <div className="container mx-auto flex items-center justify-between relative min-h-[80px]">
        
        {/* Centered logo and title */}
        <div className="absolute left-1/2 -translate-x-1/2 flex items-center gap-3">
          <img src={companyLogo} alt="Logo" className="h-20 w-auto" />
          <h1 className="text-4xl font-bold text-foreground whitespace-nowrap">
            AP Invoice Archive
          </h1>
        </div>

        {/* Right-aligned logout section */}
        {!isInvite && (
          <div className="flex flex-col items-end gap-2">
            <button
              onClick={onLogout}
              className="logout-button"
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = "#b30000")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = "#d40000")
              }
            >
              LOGOUT
            </button>

            <div className="logged-in text-sm mt-2">
              Logged In As:{" "}
              <span className="logged-in-name font-bold mt-0">{user}</span>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
